// validationSchema.ts
import { REGEX } from '@/onenetwork/constants/onenetwork.regex.const'
import * as yup from 'yup'

export const schemaUpdateAccount = yup.object({
  // province_id: yup.string().required('Tỉnh/Thành phố là bắt buộc'),
  // district_id: yup.string().required('Quận/Huyện là bắt buộc'),
  // ward_id: yup.string().required('Phường/Xã là bắt buộc'),
  full_name: yup.string().required('Họ tên là bắt buộc'),
  phone_number: yup
    .string()
    .required('Số điện thoại là bắt buộc')
    .matches(/^\d{10}$/, 'Số điện thoại không hợp lệ'),
  email: yup.string().required('Email là bắt buộc').email('Email không hợp lệ'),
  password: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value))
    .test('password-validation', 'Mật khẩu phải có ít nhất 8 ký tự', function (value) {
      if (!value) return true;
      return value.length >= 8;
    })
    .test('password-format', 'Mật khẩu chỉ được chứa chữ và số', function (value) {
      if (!value) return true;
      return REGEX.PASSWORD.test(value);
    }),
  password_confirmation: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value))
    .test('password-match', 'Mật khẩu xác nhận không khớp', function (value) {
      const { password } = this.parent;
      if (!password) return true;
      return value === password;
    })
})

export const schemaMembership = yup.object({
  package_id: yup.mixed().nullable(),
  package_expired_at: yup.mixed().when('package_id', {
    is: (val: any) => {
      return val?.code !== null && val?.code !== undefined && val?.code !== ''
    },
    then: () => yup.string().required('Ngày hết hạn gói là bắt buộc'),
    otherwise: () => yup.string().nullable(),
  }),
})

export const schemaKyc = yup.object({
  address: yup.string().required('Địa chỉ là bắt buộc'),
  province_id: yup.string().required('Tỉnh/Thành phố là bắt buộc'),
  district_id: yup.string().required('Quận/Huyện là bắt buộc'),
  // ward_id: yup.string().required('Phường/Xã là bắt buộc'),
  national_id_number: yup
    .string()
    .required('Số CMND/CCCD là bắt buộc'),
  issue_date: yup.string().required('Ngày cấp là bắt buộc'),
  issue_place: yup.string().required('Nơi cấp là bắt buộc'),
  kyc_request_date: yup.string().required('Ngày yêu cầu KYC là bắt buộc'),
  hometown: yup.string().required('Nguyên quán là bắt buộc'),
})

export const schemaCreateBOAccount = yup.object({
  full_name: yup.string().required('Họ tên là bắt buộc'),
  email: yup.string().required('Email là bắt buộc').email('Email không hợp lệ'),
  profile_image: yup.string().nullable(),
  activation_status: yup.boolean().required('Trạng thái kích hoạt là bắt buộc'),
  phone_number: yup
    .string()
    .required('Số điện thoại là bắt buộc')
    .matches(/^\d{10}$/, 'Số điện thoại không hợp lệ'),
  password: yup
    .string()
    .required('Mật khẩu là bắt buộc')
    .min(8, 'Mật khẩu phải có ít nhất 8 ký tự')
    .matches(REGEX.PASSWORD, 'Mật khẩu chỉ được chứa chữ và số'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Mật khẩu xác nhận không khớp'),
})

export const schemaUpdateBOAccount = yup.object({
  full_name: yup.string().required('Họ tên là bắt buộc'),
  email: yup.string().required('Email là bắt buộc').email('Email không hợp lệ'),
  profile_image: yup.string().nullable(),
  activation_status: yup.boolean().required('Trạng thái kích hoạt là bắt buộc'),
  phone_number: yup
    .string()
    .required('Số điện thoại là bắt buộc')
    .matches(/^\d{10}$/, 'Số điện thoại không hợp lệ'),
  password: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value))
    .test('password-validation', 'Mật khẩu phải có ít nhất 8 ký tự', function (value) {
      if (!value) return true;
      return value.length >= 8;
    })
    .test('password-format', 'Mật khẩu chỉ được chứa chữ và số', function (value) {
      if (!value) return true;
      return REGEX.PASSWORD.test(value);
    }),
  password_confirmation: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value))
    .test('password-match', 'Mật khẩu xác nhận không khớp', function (value) {
      const { password } = this.parent;
      if (!password) return true;
      return value === password;
    })
})

export const schemaChangePW = yup.object().shape({
  current_password: yup.string().required('Mật khẩu hiện tại không được để trống'),
  new_password: yup
    .string()
    .required('Mật khẩu mới không được để trống')
    .transform((value) => (value === '' ? null : value))
    .test('password-validation', 'Mật khẩu phải có ít nhất 8 ký tự', function (value) {
      if (!value) return true;
      return value.length >= 8;
    })
    .test('password-format', 'Mật khẩu chỉ được chứa chữ và số', function (value) {
      if (!value) return true;
      return REGEX.PASSWORD.test(value);
    }),
  new_password_confirmation: yup
    .string()
    .required('Xác nhận mật khẩu mới không được để trống')
    .transform((value) => (value === '' ? null : value))
    .test('password-match', 'Mật khẩu xác nhận không khớp', function (value) {
      const { new_password } = this.parent;
      if (!new_password) return true;
      return value === new_password;
    })
})